export default (that) => [
  {
    text: that.$l('btn_view_details') || '查看详情',
    icon: 'el-icon-view',
    pageType: 'detail',
  },
  {
    text: that.$l('btn_edit_product') || '编辑产品',
    icon: 'el-icon-edit',
    pageType: 'edit',
    divided: true,
    allow: 'SM',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return amzSkuStatus === 'D' ||
        (applicationStatus &&
          ['O', 'P'].includes(applicationStatus)) ||
        !that.addSku
    },

  },
  {
    text: that.$l('btn_delete_product') || '删除产品',
    icon: 'el-icon-delete',
    pageType: 'del',
    allow: 'SD',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return amzSkuStatus != 'Q' ||
        (applicationStatus &&
          ['A'].includes(applicationStatus)) ||
        !that.addSku
    },
  },
  {
    text: that.$l('btn_copy_sku') || '复制产品',
    icon: 'el-icon-document-copy',
    pageType: 'copy',
    allow: 'SE',
    disabled: ({ amzSkuStatus }) => {
      return amzSkuStatus == 'D' ||
        !that.addSku
    },
  },
  {
    text: that.$l('btn_submission_information_review') || '提交信息审核',
    icon: 'el-icon-warning-outline',
    pageType: 'submit',
    allow: 'SS',
    divided: true,
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return amzSkuStatus != 'Q' ||
        (applicationStatus &&
          ['A'].includes(applicationStatus)) ||
        !that.addSku
    },
  },

  {
    text: that.$l('btn_submission_for_order_placement') || '提交转可下单',
    icon: 'el-icon-check',
    pageType: 'change',
    allow: 'SG',
    disabled: ({ amzSkuStatus, applicationStatus }) => {
      return amzSkuStatus != 'C' ||
        (applicationStatus &&
          ['O', 'P'].includes(applicationStatus)) ||
        !that.addSku
    },
  },

]
